import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  firstName: Yup.string().trim().required("First name is required"),
  lastName: Yup.string().trim().required("Last name is required"),
  email: Yup.string().trim().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .trim()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters"),
  confirm_password: Yup.string()
    .trim()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
  companyName: Yup.string().trim().required("Company name is required"),
  subDomain: Yup.string()
    .trim()
    .required("Sub domain is required")
    .matches(/^[a-zA-Z0-9-]+$/, "Only alphanumeric characters and hyphens are allowed")
    .min(3, "Sub domain must be at least 3 characters")
    .max(63, "Sub domain must be less than 63 characters"),
  phoneNumber: Yup.string().trim().required("Phone number is required"),
  state: Yup.string().trim().required("State is required"),
  city: Yup.string().trim().required("City is required"),
  // selectedPlan: Yup.object().nullable().default(null),
  // numberOfUsers: Yup.number()
  //   .min(1, "Minimum 1 user required")
  //   .max(1000, "Maximum 1000 users allowed"),
  // selectedCoupon: Yup.string().trim(),
  // same_as_billing_address: Yup.boolean(),
  
 
  // billing_address_line_1: Yup.string()
  //   .trim()
  //   .max(255, "Billing address line 1 must be less than 255 characters")
  //   .when('selectedPlan', {
  //     is: (val) => val && val !== null,
  //     then: () => Yup.string().required("Billing address is required"),
  //     otherwise: () => Yup.string().nullable()
  //   }),
  // billing_address_line_2: Yup.string()
  //   .trim()
  //   .nullable()
  //   .max(255, "Billing address line 2 must be less than 255 characters"),
  // billing_country: Yup.string()
  //   .trim()
  //   .nullable()
  //   .max(255, "Billing country must be less than 255 characters"),
  // billing_city: Yup.string()
  //   .trim()
  //   .nullable()
  //   .max(255, "Billing city must be less than 255 characters"),
  // billing_zip_code: Yup.string()
  //   .trim()
  //   .max(10, "Billing zip code must be less than 10 characters")
  //   .when('selectedPlan', {
  //     is: (val) => val && val !== null,
  //     then: () => Yup.string().required("Billing zip code is required"),
  //     otherwise: () => Yup.string().nullable()
  //   }),
  
 
  // company_address_line_1: Yup.string()
  //   .trim()
  //   .max(255, "Company address line 1 must be less than 255 characters")
  //   .when('same_as_billing_address', {
  //     is: false,
  //     then: () => Yup.string().when('selectedPlan', {
  //       is: (val) => val && val !== null,
  //       then: () => Yup.string().required("Company address is required"),
  //       otherwise: () => Yup.string().nullable()
  //     }),
  //     otherwise: () => Yup.string().nullable()
  //   }),
  // company_address_line_2: Yup.string()
  //   .trim()
  //   .nullable()
  //   .max(255, "Company address line 2 must be less than 255 characters"),
  // company_country: Yup.string()
  //   .trim()
  //   .nullable()
  //   .max(255, "Company country must be less than 255 characters"),
  // company_city: Yup.string()
  //   .trim()
  //   .nullable()
  //   .max(255, "Company city must be less than 255 characters"),
  // company_zip_code: Yup.string()
  //   .trim()
  //   .max(10, "Company zip code must be less than 10 characters")
  //   .when('same_as_billing_address', {
  //     is: false,
  //     then: () => Yup.string().when('selectedPlan', {
  //       is: (val) => val && val !== null,
  //       then: () => Yup.string().required("Company zip code is required"),
  //       otherwise: () => Yup.string().nullable()
  //     }),
  //     otherwise: () => Yup.string().nullable()
  //   }),
});


export const BillingAndCompanySchema = Yup.object().shape({
address_line_1: Yup.string().required('Address Line 1 is required'),
address_line_2: Yup.string().optional(),
country: Yup.string().optional(),
city: Yup.string().optional(),
zip_code: Yup.string().required('Zip Code is required'),
same_as_billing_address: Yup.boolean().optional(),
company_address_line_1: Yup.string().when('same_as_billing_address', {
  is: false,
  then: () => Yup.string().required('Address Line 1 is required'),
}),
company_address_line_2: Yup.string().when('same_as_billing_address', {
  is: false,
  then: () => Yup.string().optional(),
}),
company_country: Yup.string().when('same_as_billing_address', {
  is: false,
  then: () => Yup.string().optional(),
}),
company_city: Yup.string().when('same_as_billing_address', {
  is: false,
  then: () => Yup.string().optional(),
}),
company_zip_code: Yup.string().when('same_as_billing_address', {
  is: false,
  then: () => Yup.string().required('Zip Code is required'),
}),
});